// Constants - Functions
import { protocols } from "../../../../config/constants";
import { importImages } from "../../../../config/functions";

export const GetAppRotationProtocolData = (protocolId) => {
  const protocolImg = importImages(
    require.context("../../../../assets/images/protocols/reports/app/rotation", false, /\.(png|jpe?g|svg)$/)
  );

  const protocolsData = {
    [protocols.app.rotation.ARMANOID.id]: {
      img: protocolImg["./armanoid.png"],
      imgResponsive: protocolImg["./armanoid_responsive.png"],
      name: "uppercaseProtocols_armanoid",
      description: "protocols_armanoidDescription",
      video: "protocols_armanoidVideo",
    },
    [protocols.app.rotation.DRIVING.id]: {
      img: protocolImg["./driving.png"],
      imgResponsive: protocolImg["./driving_responsive.png"],
      name: "uppercaseProtocols_driving",
      description: "protocols_drivingDescription",
      video: "protocols_drivingVideo",
    },
  };

  return protocolsData[Number(protocolId)];
};
